import CryptoJS from 'crypto-js';

/**
 * 加密配置
 * 重要：请务必与后端同学确认以下配置完全一致，否则无法解密！
 */
const config = {
  key: CryptoJS.enc.Utf8.parse('5a2ce11c0b984b81a3960066ee88b152'), // 密钥，使用 256 位（32 字节）
  iv: CryptoJS.enc.Utf8.parse('1234567890123456'),                // 偏移量，必须为 16 字节
  mode: CryptoJS.mode.ECB,                                        // 模式，推荐 ECB
  padding: CryptoJS.pad.Pkcs7                                     // 填充方式，与 Java 的 PKCS5Padding 兼容
};

/**
 * 加密方法
 * @param {string} data - 待加密的原始字符串
 * @returns {string} - 加密后的 Base64 字符串
 */
export function encrypt(data) {
  try {
    const encrypted = CryptoJS.AES.encrypt(data, config.key, {
      iv: config.iv,
      mode: config.mode,
      padding: config.padding
    });
    return encrypted.toString();
  } catch (error) {
    console.error('AES加密失败:', error);
    throw new Error('数据加密失败');
  }
}

/**
 * 解密方法
 * @param {string} encryptedData - 加密后的 Base64 字符串
 * @returns {string} - 解密后的原始字符串
 */
export function decrypt(encryptedData) {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedData, config.key, {
      iv: config.iv,
      mode: config.mode,
      padding: config.padding
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('AES解密失败:', error);
    throw new Error('数据解密失败');
  }
}